import React from 'react';
import DashboardCard from '../components/DashboardCard';
import type { DashboardMetric } from '../types/Dashboard';
import DashboardSection from '../components/DashboardSection';
import Section from '../../../components/Modular/Section';

const metrics: DashboardMetric[] = [
  {
    id: 'consultations-today',
    label: 'Consultations Today',
    value: 3,
  },
  {
    id: 'pending-consultations',
    label: 'Pending Consultations',
    value: 5,
  },
  {
    id: 'active-work-sprint',
    label: 'Current Work Sprint',
    value: 'Sprint 08',
  },
  {
    id: 'open-action-items',
    label: 'Open Action Items',
    value: 12,
  },
];

const DashboardPage = () => {
  return (
    <Section layout="flex" paddingTop="lg" paddingLeft="lg" paddingBottom="lg">
      <DashboardSection></DashboardSection>
    </Section>
  );
};

export default DashboardPage;
